import { TSelectedFilters } from '../../components/AssignFlow/types';
import { defaultFilterItem } from '../../components/AssignFlow/components/FilterItems/FilterItem';

export const defaultFilters: TSelectedFilters = {
  LegalEntityProject: defaultFilterItem,
  ProjectDepartment: defaultFilterItem,
  ApprovalManager: defaultFilterItem,
};
